"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION = exports.TEXT = exports.TEMPLATE_STR = exports.STATE_ICON_COLOR = exports.STATE_ICON = exports.STATE = exports.DEFAULT_NOTIFICATION_TYPE = exports.DEFAULT_ICON_ALT = void 0;
var STATE = {
  pending: 'pending',
  success: 'success',
  failed: 'failed'
};
exports.STATE = STATE;
var STATE_ICON = {
  pending: 'InfoOutlinedIcon',
  success: 'CheckCircleOutlineIcon',
  failed: 'HighlightOff'
};
exports.STATE_ICON = STATE_ICON;
var STATE_ICON_COLOR = {
  pending: 'yellow',
  success: 'tertiary',
  failed: 'orange'
};
exports.STATE_ICON_COLOR = STATE_ICON_COLOR;
var TRANSLATION = {
  title: 'Booking processing',
  subTitle: 'Dear {name}, we’re processing your booking and it can take up to 1 hour to confirm.',
  // eslint-disable-next-line max-len
  contentMsg1: 'We’ll send your itinerary to your email {email} and mobile phone {dialingNumber} - {mobileNumber} within 3 hours.',
  contentMsg2: 'You can also log in to your account to check the status of your booking.',
  contentMsg3: 'Your reference number is {orderId}.',
  notificationMsg: 'Covid 19 notification'
};
exports.TRANSLATION = TRANSLATION;
var TEXT = {
  flex: 'flex',
  displayFlex: 'displayFlex',
  default: 'default',
  greyDarker: 'greyDarker',
  titleSmall: 'titleSmall',
  span: 'span',
  div: 'div',
  sub: 'sub',
  titleXXLarge: 'titleXXLarge',
  secondary: 'secondary',
  small: 'small',
  tiny: 'tiny',
  XSmall: 'XSmall',
  micro: 'micro',
  center: 'center',
  block: 'block'
};
exports.TEXT = TEXT;
var TEMPLATE_STR = {
  email: "{email}",
  currency: "{currency}",
  amount: "{amount}",
  name: "{name}",
  orderId: "{orderId}",
  dialingNumber: "{dialingNumber}",
  mobileNumber: "{mobileNumber}"
};
exports.TEMPLATE_STR = TEMPLATE_STR;
var DEFAULT_NOTIFICATION_TYPE = 'info';
exports.DEFAULT_NOTIFICATION_TYPE = DEFAULT_NOTIFICATION_TYPE;
var DEFAULT_ICON_ALT = 'Processing';
exports.DEFAULT_ICON_ALT = DEFAULT_ICON_ALT;